/*eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/OrderAccounting/Commisson";

export function getAll(value) {
  return APIClient.post(`${endpoint}`, value);
}

export function getAllRole() {
  return APIClient.get(`/Role`);
}

export function getOne() {
  return APIClient.get(`${endpoint}`);
}

export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}

export function create(value) {
  return APIClient.post(`${endpoint}`, value);
}
